




































































































































import { Component, Vue} from 'vue-property-decorator'; // デコレータ
import router from '../../router';
import { ScreenName } from '@/CommonUtils/fixed/ScreenName';
import { routingControlModule } from '../../store/modules/RoutingControl'; // ルーティング制御モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import innerGroup from './VariableInnerGroup.vue';
import { UketsukeConstants } from '../fixed/UketsukeConstants';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class AccepterTopMenu extends ApiAccessBase {

  private loginName: string = 'ログイン';
  private userName: string = 'ユーザ登録';
  private loginDec: string = 'ユーザ登録済の方はこちら。';
  private userDec: string = '新規ユーザ登録はこちら。';
  private process: string = 'インターネット申請の手順';
  private news: string = 'お知らせ';
  private importantpoint: string = '注意事項';

  private getId() {
    let id = supervisingModule.GET_TENANT_ID;
    if (!id) {
      // クエリストリングからidの取得
      const tempId = this.$route.query.id;
      if (typeof tempId === 'string') {
        id = tempId;
        // ストアに保存
        supervisingModule.setTenantId(id);
      }
    }
    return id;
  }

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = '入札参加資格申請メニュー';
    this.getId();
    // 使用する可変項目の名前を指定(複数指定可)
    //this.setVariablecolsState(['acceptertopmenu_news']);
    //this.setVariablecolsState(['acceptertopmenu_news', 'acceptertopmenu_process']);
    const path: string = UketsukeConstants.ACCEPTER_TOPMENU_PATH + '/' + this.getId();
    //const path: string = Constants.ACCEPTER_TOPMENU_PATH + '/init';
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false);
    // .then((result) => {
    //     if (result === Constants.API_RESULT_SUCCES) {
    //     }
    //   },
    // );
  }
}
